import ProductsFilter from './ProductsFilter.component';

export default ProductsFilter;
